/* PB Pikachu Easter Egg — a small character that peeks from the extreme screen
   edges (mostly off-screen) as the visitor scrolls, so it never covers the
   products or their text. Position + rotation follow page scroll progress.
   Vanilla JS, rAF-throttled, passive. */
(function () {
  'use strict';

  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Waypoints across full-page scroll progress (0..1).
  // x/y are fractions of the viewport for the element's top-left corner.
  // x values sit past the edges (negative on the left, ~0.9 on the right) so
  // only a sliver of Pikachu peeks in — never over the centred content.
  var PATH = [
    { p: 0.00, x: 1.02, y: -0.24 },
    { p: 0.07, x: 0.90, y: 0.02 },
    { p: 0.22, x: -0.10, y: 0.05 },
    { p: 0.40, x: 0.92, y: 0.06 },
    { p: 0.58, x: -0.10, y: 0.78 },
    { p: 0.74, x: 0.92, y: 0.80 },
    { p: 0.90, x: -0.08, y: 0.04 },
    { p: 1.00, x: 0.95, y: 1.15 }
  ];

  function lerp(a, b, t) {
    return a + (b - a) * t;
  }

  function sample(progress) {
    for (var i = 0; i < PATH.length - 1; i++) {
      var a = PATH[i];
      var b = PATH[i + 1];
      if (progress <= b.p) {
        var span = b.p - a.p || 1;
        var t = (progress - a.p) / span;
        if (t < 0) t = 0;
        if (t > 1) t = 1;
        return { x: lerp(a.x, b.x, t), y: lerp(a.y, b.y, t) };
      }
    }
    var last = PATH[PATH.length - 1];
    return { x: last.x, y: last.y };
  }

  function init(el) {
    if (REDUCE.matches) {
      el.classList.add('is-live');
      return;
    }

    var spins = parseFloat(el.getAttribute('data-pb-spins'));
    if (isNaN(spins)) spins = 3;

    var ticking = false;
    var live = false;

    function update() {
      ticking = false;
      var doc = document.documentElement;
      var max = (doc.scrollHeight - window.innerHeight) || 1;
      var progress = window.scrollY / max;
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;

      var pos = sample(progress);
      var x = pos.x * window.innerWidth;
      var y = pos.y * window.innerHeight;
      var r = progress * 360 * spins + Math.sin(progress * Math.PI * 6) * 14;

      el.style.setProperty('--pb-x', x.toFixed(1) + 'px');
      el.style.setProperty('--pb-y', y.toFixed(1) + 'px');
      el.style.setProperty('--pb-r', r.toFixed(1) + 'deg');

      if (!live) {
        live = true;
        el.classList.add('is-live');
      }
    }

    function requestTick() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }

    window.addEventListener('scroll', requestTick, { passive: true });
    window.addEventListener('resize', requestTick, { passive: true });
    update();
  }

  function boot() {
    document.querySelectorAll('[data-pb-peek]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
